import { useEffect, useState } from "react";

import type { AchievementDefinition } from "@/types";

interface AchievementToastProps {
  achievements: AchievementDefinition[];
}

export function AchievementToast({ achievements }: AchievementToastProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible || achievements.length === 0) return null;

  return (
    <div className="fixed top-20 right-4 z-50 space-y-2">
      {achievements.map((a) => (
        <div
          key={a.id}
          className="animate-checkmark-pop flex items-center gap-3 rounded-xl border-2 border-amber-300 bg-white px-4 py-3 shadow-lg"
        >
          <span className="text-2xl">{a.icon}</span>
          <div>
            <p className="text-xs font-medium text-amber-600">Achievement Unlocked!</p>
            <p className="text-sm font-bold text-gray-900">{a.name}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
